import Vue from 'vue';

/**
 * 成功信息提示,使用方法：this.$success('操作成功',callback);
 * 注意：
 * 		1、回调方法可以不传
 * 		2、业务回调方法中不用考虑弹出层的关闭，因为封装的时候已经帮你做了
 */
Vue.prototype.$success = function(msg,callback){
	window.$root.$store.commit('setMessage',{
		type:'SUCCESS',
		content:msg,
		okCallBack:callback
	});
};
/**
 * 操作确认,使用方法：this.$confirm('确定执行此操作吗？',callback_yes,callback_no);
 * 注意：
 * 		1、回调方法可以不传
 * 		2、业务回调方法中不用考虑弹出层的关闭，因为封装的时候已经帮你做了
 */
Vue.prototype.$confirm = function(msg,callback_yes,callback_no){
	window.$root.$store.commit('setMessage',{
		type:'CONFIRM',
		content:msg,
		okCallBack:callback_yes,
		cancelCallBack:callback_no
	});
};

/**
 * 错误信息提示,使用方法：this.$error('系统错误',callback);
 * 注意：
 * 		1、回调方法可以不传
 * 		2、业务回调方法中不用考虑弹出层的关闭，因为封装的时候已经帮你做了
 */
Vue.prototype.$error = function(msg,callback){
	window.$root.$store.commit('setMessage',{
		type:'ERROR',
		content:msg,
		okCallBack:callback
	});
};